// extracted by mini-css-extract-plugin
module.exports = {"infoBox":"PageHeader_infoBox__dJqXQ","limitTextHeight":"PageHeader_limitTextHeight__15W3A","upArrow":"PageHeader_upArrow__dFt9J","downArrow":"PageHeader_downArrow__nyb9a"};